// extracted by mini-css-extract-plugin
export default {"popup":"errorPopup_popup__NYW2W","popup__title":"errorPopup_popup__title__OmiDG","popup__img":"errorPopup_popup__img__XiqG+","popup__nextBtn":"errorPopup_popup__nextBtn__EhA3B"};